/**
 * Release application entry point.
 */

'use strict';

var app = require('mag-app'),
    parallel = require('cjs-async/parallel');


// prepare shared data object
app.data = {};


// everything is ready
app.once('load', function () {
    var Canvas = require('mag-tools/canvas'),
        tasks = [
            function gettext ( done ) {
                require('spa-gettext').load({
                    name: window.core.environment.language
                }, done);
            },
            function canvas ( done ) {
                app.canvas = new Canvas({width: screen.width, height: screen.height});

                console.log('bg image ' + window.getComputedStyle(document.body).backgroundImage);
                console.log('canvas');
                app.canvas.loadImageFromBodyBackground(function ( error ) {
                    app.canvas.appendTo(document.getElementById('canvasContainer'));

                    console.log('loaded canvas, error: ' + error);
                    app.canvas = new Canvas({width: screen.width, height: screen.height});
                    document.body.style.backgroundImage = 'none';
                    done();
                });
            },
            function loadLogo ( done ) {
                var alias = window.core.backend.settings.theme;

                console.log('load logo');
                app.data.logo = {
                    url: '',
                    position: null
                };

                if ( window.core.backend.settings.themes[alias] && window.core.backend.settings.themes[alias].alias ) {
                    alias = window.core.backend.settings.themes[alias].alias;
                } else {
                    alias = 'default';
                }

                window.core.backend.request('themes/' + alias + '?colorSpace=rgba_hex&screenResolution=' + screen.width + 'x' + screen.height, {
                    onload: function ( error, response ) {
                        console.log('logo loaded ' + JSON.stringify(response.data));
                        if ( !error ) {
                            if ( response.data && response.data.logoFilename ) {
                                app.data.logo.url = response.data.logoFilename.value;
                            }

                            if ( response.data && response.data.logoAlign ) {
                                app.data.logo.position = response.data.logoAlign.value;
                            }
                        }

                        done();
                    },
                    onerror: function () {
                        console.log('logo onerror ' + this.status);
                        done();
                    },
                    ontimeout: function () {
                        console.log('logo ontimeout ' + this.status);
                        done();
                    }
                });
            }
        ];

    parallel(tasks, function () {
        // load pages
        if ( DEVELOP ) {
            try {
                app.pages = {
                    main: require('./pages/main')
                };
            } catch ( error ) {
                console.log(error);
                console.log(error.stack);
            }
        } else {
            app.pages = {
                main: require('./pages/main')
            };
        }
        // show main page
        app.route(app.pages.main);
        app.pages.main.once('ready', function () {
            app.ready();
        });
    });
});
